/**
 * Base for every server call the new pages make. Uses window.fetch, so:
 *  - live: today's token-refresh interceptor (src/legacy/services/apiInterceptor.ts) still handles 401 TOKEN_EXPIRED;
 *  - demo: the in-page demo server answers (src/mock/server.ts).
 * Never throws on a bad status: returns { ok, status, data } so screens can show a calm empty/error state.
 */
import { API_URL } from '~/config/mode'

export interface ApiResult<T> { ok: boolean; status: number; data: T | null; error: string | null }

export const authToken = () => {
  try { return localStorage.getItem('auth_token') } catch { return null }
}

export async function api<T = any>(path: string, init: { method?: string; body?: unknown; auth?: boolean } = {}): Promise<ApiResult<T>> {
  const headers: Record<string, string> = {}
  if (init.body !== undefined) headers['Content-Type'] = 'application/json'
  const token = init.auth === false ? null : authToken()
  if (token) headers.Authorization = `Bearer ${token}`
  try {
    const res = await fetch(`${API_URL}${path}`, {
      method: init.method || (init.body !== undefined ? 'POST' : 'GET'),
      headers,
      body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
    })
    let data: any = null
    try { data = await res.json() } catch { data = null }
    return { ok: res.ok, status: res.status, data: res.ok ? data : null, error: res.ok ? null : (data?.error || `Request failed (${res.status})`) }
  } catch (e) {
    return { ok: false, status: 0, data: null, error: 'Network problem. Please check your connection.' }
  }
}
